module.exports = __webpack_public_path__ + "static/media/our-partner-second.55ffb417.svg";